import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";

export interface RFMetricsData {
    all_children_plan: number | null;
    all_children_fact: number | null;
    disabled_children_plan: number | null;
    disabled_children_fact: number | null;
    diseases_total: number | null;
    diseases_first: number | null;
}

export interface RFMetricsResponse {
    success: boolean;
    data: RFMetricsData;
}

/**
 * Получить средние метрики по РФ
 */
export const getRFAverageMetrics = async (year: number): Promise<RFMetricsResponse> => {
    const token = authToken();
    const response = await fetchData(`/form30/rf-average-metrics?year=${year}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    }, 2);
    return response.json();
};
